var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"x-small":"","outlined":"","color":"secondary","loading":_vm.loading},on:{"click":function($event){$event.stopPropagation();return _vm.download(_vm.item)}}},[_vm._v("PDF")])
}
var staticRenderFns = []

export { render, staticRenderFns }